import { DefaultManufacturersEffect } from "./default-manufacturers.effect";

export const effects: any[] = [
  DefaultManufacturersEffect
];
